import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 2rem 0;
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const InfoTitleWrapper = styled.div`
  display: flex;
  width: 100%;

  & > :first-child {
    color: #898989;
    min-width: 140px;
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;

  > button {
    margin-top: 20px;
    width: 100%;
    border-radius: 20px;
    width: 170px;
    height: 35px;
    font-size: 12px;
  }
`